<template>
    <div class="modal-stat-item flex justify-between py-4 border-0 border-t border-solid border-gray-300">
        <span class="ds-text-sm uppercase font-bold text-gray-800 whitespace-no-wrap">
            {{label}}
        </span>

        <span class="ds-text-sm text-gray-700 whitespace-no-wrap">
            <slot />
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            label: { type: String, required: true },
        }
    }
</script>

<style lang="scss" scoped>
    .modal-stat-item:first-child {
        border-width: 0 !important;
    }
</style>